<template>
	<path d="M2 12s3.5-7 10-7 10 7 10 7-3.5 7-10 7-10-7-10-7Z" stroke="currentColor" stroke-width="1.6"
		stroke-linecap="round" stroke-linejoin="round" fill="none" />
	<circle cx="12" cy="12" r="3" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"
		stroke-linejoin="round" fill="none" />
</template>
